import Vue from 'vue';
import Rollbar from 'vue-rollbar';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faInfoCircle,
  faCalendarAlt,
  faCaretDown,
  faCaretRight,
  faCaretLeft,
  faLayerGroup,
  faExpand,
  faCheck,
  faSpinner,
  faPlusSquare,
  faQuestion,
  faTrashAlt,
  faPlus,
  faPen,
  faTimes,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import BootstrapVue from 'bootstrap-vue';
import VueAxios from 'vue-axios';
import VueScrollTo from 'vue-scrollto';
import App from './App.vue';
import api from './api';
import configureFilters from './configureFilters';
import configureValidation from './configureValidation';
import ErrorsPlugin from './ErrorsPlugin';
import InputErrors from './components/common/InputErrors.vue';
import router from './router';
import store from '@/store/store';
import '../sass/base.scss';
import '../sass/map.scss';

library.add(
  faInfoCircle,
  faCalendarAlt,
  faCaretDown,
  faCaretRight,
  faCaretLeft,
  faLayerGroup,
  faExpand,
  faCheck,
  faSpinner,
  faPlusSquare,
  faQuestion,
  faTrashAlt,
  faPlus,
  faPen,
  faTimes,
);

Vue.component('FontAwesomeIcon', FontAwesomeIcon);

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(VueAxios, api);
Vue.use(VueScrollTo);
Vue.use(Rollbar, {
  accessToken: 'placeholder', // overridden by SSM value after config loads
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: true,
  environment: 'development', // default; overridden by SSM value after config loads
  payload: {
    client: {
      javascript: {
        code_version: '1.0',
        source_map_enabled: true,
        guess_uncaught_frames: true,
      },
    },
  },
});

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
configureValidation();

Vue.component('InputErrors', InputErrors);
Vue.use(ErrorsPlugin);

configureFilters();

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
